import { initialValues } from 'shell/constants/initial-values-historian-search';
import { FiltersFormHistorian } from 'shell/view-models/search-historian';
import { ActionSearchHistorian } from 'store/constants/search-historian';
import { ActionHistorian } from 'store/view-models/search-historian';

function reducerHistorianSearch(
  state = initialValues,
  action: ActionHistorian
): FiltersFormHistorian {
  switch (action.type) {
    case ActionSearchHistorian.Save: {
      const { searchByFiscalCode, subjectData, ...rest } = action.payload;
      return {
        ...state,
        ...rest,
        subjectData: {
          ...state.subjectData,
          ...subjectData,
        },
        searchByFiscalCode: {
          ...state.searchByFiscalCode,
          ...searchByFiscalCode,
        },
      };
    }
    default:
      return state;
  }
}

export default reducerHistorianSearch;
